import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { HomeService } from '../shared/services/home.service';
import { Chart } from 'angular-highcharts';
import { PerformanceTrackerService } from '../shared/services/performance-tracker.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DecimalPipe } from '@angular/common'
import { LoginService } from '../services/login.service';
import { NotifierService } from 'angular-notifier';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSelect } from '@angular/material/select';
import { ExcelService } from '../shared/services/export-excel/export-excel.service';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';



interface Drops {
  drops: number;
  quest_type: string;
  question: string;
  question_id: number;
  text: string;
}
interface Terminate {
  terminate: number;
  quest_type: string;
  question: string;
  question_id: number;
  text: string;
}
interface Response {
  id?: string;
  reached: number;
  required: number;
}
interface TotalResponse {
  totalResponse: number;
}
interface AverageResponse {
  average: number;
  reqAverage: number;
}
interface Quota {
  id?: string;
  count_type: number;
  max_count: number;
  name: string;
  parent_id: string;
  quota_count: number;
  status: number;
  subQuota: SubQuota[];
}
interface SubQuota {
  id?: string;
  count_type: number;
  max_count: number;
  name: string;
  parent_id: string;
  quota_count: number;
  status: boolean;
}
interface QuotaDetails {
  getNames?: string;
  drops?: Drops[];
  terminate: Terminate[];
  response: Response;
  totalResponse: TotalResponse;
  averageResponse: AverageResponse;
}

class ITCFilter {
  cities: any = [];
  city: any = [];
  volumes: any = [];
  volume: string = '';
  categoryTypes: any = [];
  categoryType: string = '';
  categories: any = [];
  category: any = [];
  brands: any = [];
  brand: any = [];
  allCategories: any = [];
}

@Component({
  selector: 'app-performance-tracker',
  templateUrl: './performance-tracker.component.html',
  styleUrls: ['./performance-tracker.component.scss']
})
export class PerformanceTrackerComponent implements OnInit, OnDestroy {

  @ViewChild('focuseIn', {static: false}) focuseIn : ElementRef<HTMLInputElement>;
  @ViewChild('citySelect', {static: false}) citySelect: MatSelect;
  
  chart = new Chart();
  quotaDetails: QuotaDetails;
  dropData: Drops[] = [];
  quotasAll: Quota[] = [];
  quotasWaveAll: any[] = [];
  subQuotas: any;
  launchedAt:string;
  terminatedData: Terminate[] = [];
  response: Response;

  isTool: boolean = false;
  isId: boolean = false;

  isViewDetails: boolean = true;
  isDropOff: boolean = true;
  toggleShowAll: boolean = false;
  isSubQuota: boolean = false;
  isSubSubQuota: boolean = false;
  isDataDrops: boolean = true;
  isTerminationDrops: boolean = true;
  isQuotaData: boolean = true;
  isSubQuotaData: boolean = true;
  downloadReport: boolean = false;
  downloadRldReport: boolean = false;
  downloadSpssReport: boolean = false;
  isfunnelReport: boolean = false;
  isSubAvgLoaded: boolean = false;
  isQuotaReport:boolean = false;
  noData: boolean = true;
  chartState: string = 'empty';
  startDate: string;
  endDate: string;
  dateCount: number[] = [0];
  dateAll: string[] = [];
  //overall Response
  averageResponse: number = 0;
  requiredAverage: number = 0;
  //quota Response
  averageQuotaResponse: number = 0;
  requiredQuotaAverage: number = 0;
  //subQuota response
  averageSubResponse: number = 0;
  requiredSubAverage: number = 0;
  // incedenceRate: number = 59.6;
  quotaCompleted: number = 0;
  totalNoDAys: number = 0;
  daysLeft: number = 0;
  currentResponce: number = 0;
  totalMaxResponce: number = 0;
  totalResponse: number = 0;
  totalAllResponses: number = 0;
  ir: number = 0;
  dropOffProgressPercentage: number = 0;
  terminatedProgressPercentage: number = 0;
  tableItems: any;
  menu: string;
  detailsName: string;
  detailsNameFull: string;
  studyId: string;
  quotaCollapse: string;
  quotasubCollapse: number;
  sumDrops: number = 0;
  sumTerminate: number = 0;
  isChartResponce: string = 'wating';
  errorText: string = 'Something went wrong';
  month_names = ["Jan", "Feb", "Mar",
    "Apr", "May", "Jun",
    "Jul", "Aug", "Sep",
    "Oct", "Nov", "Dec"];
  rootProjectName: string = "";
  rootProjectUrl: string = "";
  performaceTrackerData: any = [];
  accessRoles: any = [];
  totalclassCase: string = "";

  // ---------------performance tracker ITC------------------
  isITCStudy: boolean = false;
  issubCatItcIndex: number = 0;
  isItemItcIndex: number = 0;
  isItcIndex: number = -1;
  itcFilterSubcity: any = [];
  itcFilterItemcity: any = [];
  itcFilter = new ITCFilter();
  itcData: any = [];
  itcFilterData: any = [];
  itcHeader: any = [];
  itemWiseHeader: any = [];
  itemWiseData: any = [];
  itemWiseFilterData: any = [];
  subCatWiseHeader: any = [];
  subCatWiseCities: any;
  itemWiseCities: any;
  subCatWiseData: any = [];
  subCatWiseFilterData: any = [];
  placeITC: any = ['GT', 'MT', 'OT'];
  skuSizeITC: any = ['1', '5', '10', 'other', 'NA'];

  // ---------------performance tracker AR start------------------
  public isMetro: boolean = false;
  public arStartDate: any = null;
  public arEndDate: any = null;
  public showFoodAr: boolean = false;
  // public isResponse: boolean = false;
  // public isTotalMaxRes: boolean = false;
  // public isDaysLeft: boolean = false;
  // public arStartDate: any = new Date();
  // public arEndDate: any = this.arStartDate.setDate(this.arStartDate.getDate() - 7);
  public arData: any = { 'analysis_data': [] };
  public todayDate: any;
  public dictionary: any;
  public noARData: boolean = false;
  public isLoading: boolean = false;
  public isMasterAccount: boolean = false;

  // ---------------performance tracker AR end------------------

  constructor(
    public homeService: HomeService,
    private performanceService: PerformanceTrackerService,
    public sanitization: DomSanitizer,
    private decimalPipe: DecimalPipe,
    private router: Router,
    private excelService: ExcelService,
    private sidePanel: SidePanelService,
    private notifier: NotifierService,
    private logerror: LoginService,
    private activatedRoute: ActivatedRoute) {
    this.homeService.sidenav2Open.next(true);
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.isMasterAccount = this.accessRoles['account_type'] && this.accessRoles['account_type'] == 'Master' ? true : false;
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  public hideOldestNotification(): void {
    this.notifier.hideOldest();
  }

  changeTooltip(event: any, index: any) {
    this.isId = index;
    event.type === 'mouseover' ? this.isTool = true : this.isTool = false;
  }

  ngOnDestroy() {
    this.hideOldestNotification();
  }

  ngOnInit() {
    if(this.sidePanel.visibilityData){
      this.sidePanel.visibilityData = null;
    }
    this.activatedRoute.params.subscribe((studyID) => { this.studyId = studyID.id; });
    
    if(this.router.url.includes('pt-event')){
      this.studyId = this.homeService.getPtEventStudyId();
      this.sidePanel.studyId = this.studyId;
      // this.sidePanel.initSideDrawer("PT");
    }else{
      this.sidePanel.studyId = this.studyId;
      this.sidePanel.initSideDrawer(localStorage.getItem('studyTYPE'));
    }
    localStorage.setItem('studyId',this.studyId);
    
    this.itcFilter.categoryTypes = { "1": { "name": "", "label": "Categories" }, "2": { "name": "", "label": "Sub Categories" }, "3": { "name": "", "label": "Item" } };
    this.itcFilter.categoryType = '2';
    this.itcFilter.city = ['all'];
    this.itcFilter.volumes = 
        {
          "1": {"name":"quantity","key":"Volume in units"},
          "2": {"name":"quantity_perc","key":"Volume in % of total units"},
          "3": {"name":"price_perc","key":"Value in % of total bill value"},
          "4": {"name":"price","key":"Value in INR"}
        }
    this.itcFilter.volume = '1';
    let today = new Date();
    this.todayDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    this.homeService.sidenav2Open.next(true);
    this.getStudyVisibility();
    this.performanceService.getQuotaDetails(this.studyId).subscribe(
      (data) => {
        if (data.result && Object.keys(data.result).length) {
          // this.terminatedData = data.result['terminate'];
          this.launchedAt = data.result['launchedAt'];
          // this.dropData = data.result['drops'];
          this.averageResponse = data.result['averageResponse']['average'];
          this.requiredAverage = data.result['averageResponse']['reqAverage'];
          this.averageQuotaResponse = this.averageResponse;
          this.totalResponse = data.result['responses']['required'];
          this.quotasAll = data.result['subquota'];
          this.mapQuotaWaveWise();
          this.quotasAll.forEach((element, index) => {
            let j = 1;
            element['subqouta'].forEach((subelement, indexsub) => {
              if (subelement.user_count > 0) {
                this.quotasAll[index]['quotaRc'] = j;
                j++;
              }
              //    j++;
            });
          });
          // this.dropData.forEach((data) => {
          //   this.sumDrops = this.sumDrops + data.drops;
          // });
          if (this.quotasAll.length === 0) {
            this.isQuotaData = true;
          }
          else {
            this.isQuotaData = false;
          }
          // if (this.dropData.length === 0) {
          //   this.isDataDrops = true;
          // } else {
          //   this.isDataDrops = false;
          // }
          // if (this.terminatedData.length === 0) {
          //   this.isTerminationDrops = true;
          // } else {
          //   this.isTerminationDrops = false;
          // }
          // this.terminatedData.forEach((data) => {
          //   this.sumTerminate = this.sumTerminate + data.terminate;
          // });
          this.totalAllResponses = data.result['totalResponses'][0]['totalResponse'];
          // this.dropOffProgressPercentage = this.sumDrops / this.totalAllResponses * 100;
          // this.dropOffProgressPercentage = +(this.decimalPipe.transform(this.dropOffProgressPercentage, '1.1-1'));
          // this.terminatedProgressPercentage = this.sumTerminate / this.totalAllResponses * 100;
          // this.terminatedProgressPercentage = +(this.decimalPipe.transform(this.terminatedProgressPercentage, '1.1-1'));
          this.ir = Number(data.result['ir']);
          this.dropOffProgressPercentage = Number(data.result['dropOffPercentage']);
          this.terminatedProgressPercentage = Number(data.result['terminatedPercentage']);
        }
        this.noData = true;
      },
      error => { // error path
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.noData = false;
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.errorText = 'Something went wrong';
          this.noData = false;
        }
      }
    );
    this.performanceService.getResponseDateQuota(this.studyId).subscribe(
      (data) => {
        if (data.result && Object.keys(data.result).length) {
          this.currentResponce = data.result['responses'];
          this.detailsName = data.result['details']['name'].length > 80 ? data.result['details']['name'].slice(0, 80) + '...' : data.result['details']['name'];
          this.detailsNameFull = data.result['details']['name'];
          if (data.result['projectOfStudies']) {
            this.rootProjectName = data.result['projectOfStudies']['name'];
            this.rootProjectUrl = data.result['projectOfStudies']['uuid'];
          }
          this.totalMaxResponce = data.result['maxResponse'];
          // this.sidePanel.SurveyId = data.result['api_survey_id'];
          // this.sidePanel.prevChannel = data.result['prevChannel'] ? data.result['prevChannel'] :'';
          this.daysLeft = data.result['days'];
          this.quotaCompleted = data.result['quotas']['quotaCompleted'];
          const endDate = new Date(data.result['details']['endDate']).getTime();
          const checkStartDate = new Date(data.result['details']['startDate']);
          let startDate: Date;
          let end: Date;
          const today = new Date().getTime();
          if (endDate >= today) {
            end = new Date();
          } else {
            end = new Date(data.result['details']['endDate']);
          }
          this.endDate = (end.getFullYear() + '-' + ('0' + (end.getMonth() + 1)).slice(-2) + '-' + ('0' + end.getDate()).slice(-2) + ' ' + ('0' + end.getHours()).slice(-2) + ':' + ('0' + end.getMinutes()).slice(-2) + ':' + ('0' + end.getSeconds()).slice(-2));
          // end = new Date(data.result['details']['endDate']);
          startDate = new Date(end.setDate(end.getDate() - 21));

          // console.log(checkStartDate + "  checkStartDate.getTime() ====>",checkStartDate.getTime() )
          // console.log(startDate+"  startDate.getTime() ====>",startDate.getTime() )
          if (checkStartDate.getTime() > startDate.getTime()) {
            startDate = checkStartDate;
          }

          // console.log("  startDate.getTime() 111====>",startDate )
          if(data.result.api_survey_id && data.result.api_survey_id === 12703){
            this.sidePanel.isDiarySurvey = true;
            this.sidePanel.initSideDrawer('home');

          }
          this.startDate = (startDate.getFullYear() + '-' + ('0' + (startDate.getMonth() + 1)).slice(-2) + '-' + ('0' + startDate.getDate()).slice(-2) + ' ' + ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2) + ':' + ('0' + startDate.getSeconds()).slice(-2));
          this.getDailyResponseRate();
        }
      },
      (error) => { // error path
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.noData = false;
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.errorText = 'Something went wrong';
          this.noData = false;
        }
      }
    );
    if (this.studyId == 'f0792c80-091f-4e08-85e0-0321d2cc3eb9') {
      this.getARPerformance();
    }
    if(!this.router.url.includes('pt-event')){
      this.sidePanel.getVisibility(this.studyId);
    }
    this.getSurveyDataBasedOnStudyId(this.studyId);
    this.homeService.checkRepoDetailsEvent.emit(this.studyId);
  }

  getSurveyDataBasedOnStudyId(studyId){
    this.performanceService.getSurveyDataBaseOnStudyId(studyId).subscribe((res:any) =>{
      if(res && res.status){
        if(res.result && Object.keys(res.result).length){
          this.sidePanel.SurveyId = res.result.api_survey_id;
          this.sidePanel.prevChannel = res.result.prevChannel;
          localStorage.setItem('SurveyId',this.sidePanel.SurveyId);
          localStorage.setItem('prevChannel',this.sidePanel.prevChannel)
        }
      }
    })
  }



  initChart() {
    const chart = new Chart({
      chart: {
        type: 'line'
      },
      title: {
        text: ' '
      },
      xAxis: {
        categories: this.dateAll,
        lineColor: '#979797',
        lineWidth: 1,
      },
      yAxis: {
        title: { text: 'Response', style: { color: '#333333', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', fill: '#333333' } },
        lineColor: '#979797',
        lineWidth: 1,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'

      },
      tooltip: {
        formatter: function () {
          return 'Responses<br><b>' + this.y + '</b>';
        },
        useHTML: true,
      },
      credits: {
        enabled: false
      },
      series: [
        <Highcharts.SeriesColumnOptions>{
          name: 'Date',
          color: '#121b5a',
          data: this.dateCount
        }]
    });
    this.chart = chart;
    // console.log("chart =>", this.chart);
  }

  quotaReport(){
    this.performanceService.getDownloadQuotaReport(this.studyId).subscribe((data) => {
      if (data.status === 1) {
          this.excelService.exportAsExcelFile(data['response'], this.detailsNameFull);
      } else {
        this.showNotification('error', data['response']['errorMessage']);
      }
    },
      error => { // error path
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.showNotification('error', 'User is not authorised');
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.showNotification('error', 'Something went wrong');
        }
      });
  }

  generateReport(requestType: string) {
    this.performanceService.getDownloadReport(this.studyId, requestType).subscribe((data) => {
      if (data.status === 1) {
        this.showNotification('info', 'Process Initiated. You will receive the report in your inbox  within 30 minutes');

      } else {
        this.showNotification('error', 'Something went Wrong');
      }
    },
      error => { // error path
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.noData = false;
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.errorText = 'Something went wrong';
          this.noData = false;
        }
      });
  }

  // showAllData() {
  //   this.toggleShowAll = !this.toggleShowAll;
  //   if (!this.toggleShowAll) {
  //     this.tableItems = this.isDropOff ? this.dropData.slice(0, 10) : this.terminatedData.slice(0, 10);
  //   } else {
  //     this.tableItems = this.isDropOff ? this.dropData : this.terminatedData;
  //   }
  // }

  collapseSubQuota(index: number, quotaId: string) {
    if (this.quotaCollapse === quotaId) {
      this.isSubQuota = !this.isSubQuota;
    } else {
      this.isSubQuota = true;
    }
    this.quotaCollapse = quotaId;
    if (this.isSubQuota) {
      this.getQuotaDetailsWithId(quotaId, 1);
    }
  }

  collapsSubSubQuota(index: number, quotaId: string) {
    if (this.quotasubCollapse === index) {
      this.isSubSubQuota = !this.isSubSubQuota;
    } else {
      this.isSubSubQuota = true;
    }
    this.quotasubCollapse = index;
    if (this.isSubSubQuota) {
      this.getQuotaDetailsWithId(quotaId, 2);
    }
  }

  // toggleViewDetails(menu: string) {
  //   if (this.menu === menu) {
  //     this.isViewDetails = !this.isViewDetails;
  //   } else {
  //     this.isViewDetails = false;
  //   }
  //   this.menu = menu;
  //   if (menu === 'drop') {
  //     this.isDropOff = true;
  //     this.tableItems = this.dropData.slice(0, 10) || [];
  //   } else {
  //     this.isDropOff = false;
  //     this.tableItems = this.terminatedData.slice(0, 10) || [];
  //   }
  // }

  subQuotaType(subQuotaId: number) {
    if (subQuotaId === 1) {
      return ' of Exactly ';
    } else if (subQuotaId === 2) {
      return ' of Atleast ';
    } else {
      return ' of Atmost ';
    }
  }

  subQuotaPercentage(subQuotaUser: number, subQuotaMax: number, subQuotaId: number, quotaCount: number): number {
    if (subQuotaId === 1) {
      if (subQuotaUser > subQuotaMax) {
        return 100;
      }
      return +(this.decimalPipe.transform(subQuotaUser / subQuotaMax * 100, '1.1-1'));;
    } else if (subQuotaId === 2) {
      if (subQuotaUser > quotaCount) {
        return 100;
      }
      return +(this.decimalPipe.transform(subQuotaUser / quotaCount * 100, '1.1-1'));
    } else {
      return subQuotaUser > 0 ? 100 : 0;
    }
  }

  getDailyResponseRate() {
    this.performanceService.getDailyResponseRate(this.studyId, this.startDate, this.endDate).subscribe(
      (data) => {
        if (data.result && Object.keys(data.result).length) {
          this.dateCount.pop();
          data.result.forEach((datesData) => {
            const check: Date = new Date(datesData['date']);
            this.dateCount.push(datesData['count']);
            this.dateAll.push(check.getDate() + " " + this.month_names[check.getMonth()]);
          });
        }
        if (this.dateCount.length > 0 && this.dateAll.length > 0) {
          this.isChartResponce = 'chart';
        } else if (this.dateCount.length > 0) {
          this.isChartResponce = 'activity'
        }
        else {
          this.isChartResponce = 'wating'
        }
        this.initChart();
      },
      (error) => { // error path
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.noData = false;
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.errorText = 'Something went wrong';
          this.noData = false;
        }
      });
  }

  getQuotaDetailsWithId(quotaId: string, typeCh: number) {
    this.isSubAvgLoaded = false;
    this.performanceService.getSubQuotaDetails(this.studyId, quotaId).subscribe(
      (data) => {
        if (data.result.length !== 0) {
          if (typeCh === 1) {
            this.averageQuotaResponse = data.result['averageResponse']['average'];
            this.requiredQuotaAverage = data.result['averageResponse']['reqAverage'];
            this.isSubAvgLoaded = true;
          } else {
            this.averageSubResponse = data.result['averageResponse']['average'];
            this.requiredSubAverage = data.result['averageResponse']['reqAverage'];
            this.isSubAvgLoaded = true;
          }
        }
      },
      (error) => { // error path
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.noData = false;
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.errorText = 'Something went wrong';
          this.noData = false;
        }
      });
  }

  getStudyVisibility() {
    this.performanceService.getStudyVisibility(this.studyId).subscribe(
    (data) => {
      this.accessRoles = JSON.parse(localStorage.getItem('access'));
      if (data.data) {
        const data_parse = JSON.parse(data.data);
        // console.log("data_parse",data_parse);
        if (data_parse?.performaceTracker?.show == true) {
          this.performaceTrackerData = data_parse.performaceTracker.els;

          if (this.accessRoles.super != true && (this.performaceTrackerData.dropOff == false || this.performaceTrackerData.terminations == false)) {
            this.totalclassCase = "grid-case-1";
          }
          if (this.accessRoles.super != true && (this.performaceTrackerData.dropOff == false && this.performaceTrackerData.terminations == false)) {
            this.totalclassCase = "grid-case-2";
          }
        }
       
        if(data_parse.analysisReport && data_parse.analysisReport.els) {
          this.downloadReport = data_parse.analysisReport.els.downloadReport;
          this.downloadRldReport = data_parse.analysisReport.els.rldReport;
          this.downloadSpssReport = data_parse.analysisReport.els.spssReport;
        }
        if (data_parse.funnelReport && data_parse.funnelReport.show) {
          this.isfunnelReport = data_parse.funnelReport.show;
        }
        if(data_parse.quotaReport && data_parse.quotaReport.show){
          this.isQuotaReport = data_parse.quotaReport.show;
        }
    

        if(this.accessRoles.org_id == 'cb9f120a-284a-11e9-83cd-42010a8e0002' || this.accessRoles.org_id == "d69b3be6-3133-11e9-8d02-42010aa0000a"){
          this.isQuotaReport = true;
        }

        if (data_parse.billAnalysis && data_parse.billAnalysis.show) {
          this.isITCStudy = true;
          this.getITCData();
        }
      }
      if((this.accessRoles.org_id == 'cb9f120a-284a-11e9-83cd-42010a8e0002' || this.accessRoles.org_id == 'd69b3be6-3133-11e9-8d02-42010aa0000a') && (this.accessRoles['access_type'] == 'admin' || this.accessRoles.super == true)){
        this.isQuotaReport = true;
      }
    },
    (error) => { // error path
      if (error.status === 403) {
        this.router.navigate(['home/access-denied']);
      }
      else if (error.status === 401) {
        this.errorText = 'User is not authorised';
        this.noData = false;
        this.router.navigate(['home/access-denied']);
      }
      else {
        this.errorText = 'Something went wrong';
        this.noData = false;
      }
    });
  }

  recruiterMenu(type) {
    if (type === 'all') {
      this.router.navigate(['/home/projects']);
    } else {
      this.router.navigate(['/home/projects', this.rootProjectUrl]);
    }
  }

  getSubQuotaCompleted(subQuota: any): number {
    let count = 0;
    subQuota.forEach((quotaData) => {
      const percentCheck = this.subQuotaPercentage(quotaData['user_count'], quotaData['max_count'], quotaData['count_type'], quotaData['quota_count']);
      if (percentCheck >= 100) {
        count++;
      }
    });
    return count;
  }

  checkMax(minValue: any, maxValue: any): any {
    return minValue > maxValue ? maxValue : minValue;
  }

  removeTags(question: string): string {
    return question.replace(/<[^>]*>/g, '');
  }

  funnelReport() {
    this.performanceService.funnelReport(this.studyId).subscribe(
      (data) => {
        if (data.status == 1) {
          this.showNotification('success', 'Successful');
        } else {
          this.showNotification('error', 'Something went Wrong');
        }
      },
      (error) => {
        if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.noData = false;
          this.router.navigate(['home/access-denied']);
        } else {
          this.showNotification('error', 'Something went Wrong');
        }
      });
  }

  // ---------------performance tracker AR start------------------

  selectCity(cityValue: boolean) {
    this.isMetro = cityValue;
    if (this.arStartDate == undefined || this.arEndDate == undefined) {
      this.arStartDate = null;
      this.arEndDate = null;
      this.getARPerformance();
    } else {
      let start = new Date(this.arStartDate);
      let end = new Date(this.arEndDate);
      let today = new Date();
      if (start > end) {
        this.showNotification('error', 'Start date is greater than end date.');
      } else {
        this.getARPerformance();
      }
    }
  }

  getDateSelected() {
    let start = new Date(this.arStartDate);
    let end = new Date(this.arEndDate);
    let today = new Date();
    if ((this.arStartDate && this.arEndDate) && (start > end)) {
      this.showNotification('error', 'Start date is greater than end date.');
    } else {
      this.getARPerformance();
    }
  }

  getARPerformance() {
    this.isLoading = true;
    let arDataArg: any = { 'studyId': this.studyId, 'start': this.formateSql(this.arStartDate), 'end': this.formateSql(this.arEndDate) };
    // let arDataArg: any = { 'surveyId': 2766, 'startDate': this.arStartDate, 'endDate': this.arEndDate };
    this.performanceService.getARData(arDataArg).subscribe((result) => {
      this.isLoading = false;
      if (result.status == 1) {
        if (result) {
          this.arData.analysis_data = result;
          this.dictionary = this.arData.analysis_data.dictionary.ui_layout;
          this.arData.analysis_data = (!this.isMetro ? this.arData.analysis_data.analysis.all_cities : this.arData.analysis_data.analysis.metro_vs_nonMetro);
          this.showFoodAr = true;
        }
      } else {
        this.showNotification('error', 'Something went wrong');
        this.noARData = true;
      }
    },
      error => {
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.noARData = true;
        }
        else {
          this.errorText = 'Something went wrong';
          this.noARData = true;
        }
      });
  }

  formateDate(date: any): any {
    let formateD: any = date;
    formateD = formateD.split('-');
    formateD = new Date((formateD[1] + '-' + formateD[0] + '-' + formateD[2]));
    if (formateD != "Invalid Date" || !isNaN(formateD)) {
      formateD = (formateD.getDate() + '/' + (formateD.getMonth() + 1) + '/' + formateD.getFullYear());
      return formateD;
    } else {
      formateD = date;
      formateD = formateD.replace(/_/g, ' ');
      return formateD;
    }
  }

  formateSql(date: any): string {
    if (date) {
      let today = new Date(date);
      date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' 00:00:00';
    }
    return date;
  }

  removeUnder(cap): string {
    let replaced = cap;
    replaced = replaced.replace(/_/g, ' ');
    return replaced;
  }

  styleTrust(data: any): any {
    return this.sanitization.bypassSecurityTrustStyle(data);
  }

  // sortDateWise(data): any {
  //   let formateD: any = data[0].date;
  //   let tempData: any = [];
  //   formateD =  (formateD != undefined ? formateD.split('-'): "Invalid Date");
  //   formateD = new Date((formateD[1] + '-' + formateD[0] + '-' + formateD[2]));
  //   if (formateD != "Invalid Date" || !isNaN(formateD)) {
  //     for (let i = 0; i < data.length; i++) {
  //       for (let j = 0; j < data.length; j++) {
  //         if(this.checkDate(data[i], data[j])){
  //           let temp:any = data[i];
  //           data[i] = data[j];
  //           data[j] = temp;
  //         }
  //       }
  //     }
  //   }
  //   return data;
  // }

  // checkDate(data:any, data2:any):any{
  //   let date1:any = data.date;
  //   let date2:any = data2.date;
  //   date1 = new Date((date1[1] + '-' + date1[0] + '-' + date1[2]));
  //   date2 = new Date((date2[1] + '-' + date2[0] + '-' + date2[2]));
  //   return (date1 > date2);
  //   return (date1 - date2);
  // }
  // ---------------performance tracker AR end------------------

  // ---------------performance tracker ITC start------------------

  switchITCmenu(index) {
    this.isItcIndex = (this.isItcIndex == -1 || this.isItcIndex != index ? index : -1);
  }

  switchSubCatITCmenu(index) {
    this.issubCatItcIndex = (this.issubCatItcIndex == -1 || this.issubCatItcIndex != index ? index : -1);
  }

  switchItemITCmenu(index) {
    this.isItemItcIndex = (this.isItemItcIndex == -1 || this.isItemItcIndex != index ? index : -1);
  }

  switchCategoryType() {
    this.itcFilter.category = [];
    if(this.itcFilter.categoryType == '1'){
      this.itcFilterData = this.itcData['data']['category_wise'];
    }else{
      this.itcFilterData = this.itcData['data']['subcategory_wise'];
    }
  }

  clearFilter(filter: any) {
    if (filter == 1) {
      this.itcFilter.volume = undefined;
      this.itcFilter.categoryType = undefined;
      this.itcFilter.category = [];
      this.itcFilter.brand = [];
    }
    if (filter == 2) {
      this.itcFilter.categoryType = undefined;
      this.itcFilter.category = [];
      this.itcFilter.brand = [];
    }
    if (filter == 3) {
      this.itcFilter.category = [];
      this.itcFilter.brand = [];
    }
    if (filter == 4) {
      this.itcFilter.brand = [];
    }
    if (filter == 5) {
      this.itcFilter.city = [];
    }
    if (filter != 'sub' || filter != 'item') {
      this.itcFilterData = this.itcData['data'];
    }
    if (filter == 'sub') {
      this.itcFilterSubcity = [];
      this.itemWiseFilterData = this.subCatWiseData['data'];
    }
    if (filter == 'item') {
      this.itcFilterItemcity = [];
      this.itemWiseFilterData = this.itemWiseData['data'];
    }
  }

  applyITCFilters() {

  }

  getTotalValue(head:string, type):number{
    let totalRowValue:number = 0;
      this.itcFilterData.forEach(row => {
        if (row[head]) {
              totalRowValue = totalRowValue + (row[head][type] || 0);
          }
      });
      return totalRowValue;
  }

  getITCPercentage(num: number, den: number) {
    let percentage: any = ((num / den) * 100);
    percentage = isNaN(percentage) ? '(0%)' : ('(' + percentage.toFixed(1) + '%)');
    return percentage;
  }

  getITCData() {
    setTimeout(() => {
      this.getBillAnalysisData();
      // this.getItemWiseData();
      this.getSubCategoryWiseData();
    });
  }

  getBillAnalysisData() {
    let data = { study_id: '1713', cities: JSON.stringify(this.itcFilter.city.includes('all') ? [] : this.itcFilter.city) };
    this.performanceService.getBillAnalysisData(data).subscribe(result => {
      if (result['status'] == 1) {
        this.itcData = result;
        this.itcFilterData = result['data']['subcategory_wise'];
        this.itcFilter.cities = result['city'];
        this.itcHeader = this.itcData['header'];
        this.itcHeader.unshift('name');
        if (this.itcFilter.categoryType) {
          // this.applyITCFilters();
        }
      }
    });
  }
  
  clickEnabled(obj: any) {
    obj.opened = true;
    if (obj.id == "mat-datepicker-0") {
      this.endDate = this.todayDate;
    }
  }

  getItemWiseData() {
    let data = { study_id: '1713', cities: JSON.stringify(this.itcFilterItemcity.includes('all') ? [] : this.itcFilterItemcity) };
    this.performanceService.getItemWiseData(data).subscribe(result => {
      if (result['status'] == 1) {
        this.itemWiseFilterData = result['data'];
        this.itemWiseData = result;
        this.itemWiseHeader = [];
        this.itemWiseCities = result['filters']['city'];
        this.itemWiseData['headers'].forEach((key) => {
          if (key != 'value') {
            this.itemWiseHeader.push(key);
          } else {
            this.itemWiseHeader.push('price');
          }
        });
      }
    });
  }

  getSubCategoryWiseData() {
    let data = { study_id: '1713', cities: JSON.stringify(this.itcFilterSubcity.includes('all') ? [] : this.itcFilterSubcity) };
    this.performanceService.getSubCategoryWiseData(data).subscribe(result => {
      if (result['status'] == 1) {
        this.subCatWiseFilterData = result['data'];
        this.subCatWiseData = result;
        this.subCatWiseHeader = [];
        this.subCatWiseCities = result['filters']['city'];
        this.subCatWiseData['headers'].forEach((key) => {
          if (key != 'value') {
            this.subCatWiseHeader.push(key);
          } else {
            this.subCatWiseHeader.push('price');
          }
        });
      }
    });
  }

  mapQuotaWaveWise(){
    this.quotasWaveAll = [];
    let waveDefault = {name:'Defaut Wave', quota:[]};
    let seqID = [];
    let count = 1;

    this.quotasAll.forEach((quota)=>{
      if(quota['seq_no']){
        let wave = {name:'Wave '+ count, quota:[]};
        if(!seqID.includes(quota['id'])){
          wave['quota'].push(quota);
          seqID.push(quota['id']);
        }
        this.quotasAll.forEach((quotaInner)=>{
          if(quota['seq_no'] == quotaInner['seq_no'] && !seqID.includes(quotaInner['id'])){
            wave['quota'].push(quotaInner);
            seqID.push(quotaInner['id']);
          }
        });
        if(wave['quota'].length > 0){
          this.quotasWaveAll.push(wave);
          count++;
        }
      }else{
        waveDefault['quota'].push(quota);
      }
    });
    this.quotasWaveAll.push(waveDefault);
  }

}
